import { useActivateCampaignToggle } from 'entities/campaign';
import type { ManagerGetCampaignModel } from 'entities/campaign';
import { Button } from 'shared/ui/Button';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

interface ReactivateCampaignProps {
  campaign: ManagerGetCampaignModel;
  onSuccess?: () => void;
}

export function ReactivateCampaign({ campaign, onSuccess }: ReactivateCampaignProps) {
  const activateCampaignToggleQuery = useActivateCampaignToggle(campaign.id);

  return (
    <Button
      className="mt-4"
      type="button"
      disabled={activateCampaignToggleQuery.isLoading}
      onClick={() => activateCampaignToggleQuery.mutateAsync().then(onSuccess)}
      size="medium"
      {...getDataAutoTestAttributes(['button-reactivate-campaign'])}
    >
      Reactivate campaign
    </Button>
  );
}
